var K = Object.defineProperty;
var X = (e, t, i) => t in e ? K(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var u = (e, t, i) => (X(e, typeof t != "symbol" ? t + "" : t, i), i);
import { reactive as v, provide as E, onMounted as q, inject as L, getCurrentInstance as D } from "vue";
import { c, h as g, R as f, M as V, B as I, i as d, D as w, j as O, p as B, k as j, C as U, l as N } from "./maps.D7VdAXi0.js";
var b = /* @__PURE__ */ ((e) => (e.Active = "active", e.Sending = "sending", e.Success = "success", e.Failure = "failure", e))(b || {});
const Z = [
  c.SendForm,
  c.SendSaveSearch,
  c.SendSubscribe
], W = [
  // TODO: add empty click here and update button component
  c.ApplyDiscount,
  c.OpenUri,
  c.OpenBookingEngine,
  c.EmptyClick,
  c.Dismiss
], G = [
  c.Hide
];
class J {
  constructor() {
    u(this, "dataValidators", {});
    u(this, "state", v({
      actions: [],
      buttonState: b.Active,
      stepActive: g.Main,
      stepPrevious: null,
      isFirstStep: !0,
      hideFunction: () => {
      }
    }));
  }
  get buttonState() {
    return this.state.buttonState;
  }
  get isFirstStep() {
    return this.state.isFirstStep;
  }
  get stepActive() {
    return this.state.stepActive;
  }
  get stepPrevious() {
    return this.state.stepPrevious;
  }
  initialize(t, i) {
    this.state.hideFunction = t, this.state.actions = i;
  }
  setStepActive(t, i = null) {
    this.state.stepActive = t, this.state.isFirstStep = t === g.Main, this.state.stepPrevious = i;
  }
  setDataValidator(t, i) {
    console.log("setDataValidator", t, i), this.dataValidators[t] = i;
  }
  // accep type as generic for return
  async callHandler(t, i) {
    if (!this.state.actions)
      return !1;
    let s = {};
    const o = this.dataValidators[t];
    if (o && (s = await o(), !s))
      return !1;
    let n;
    const r = [
      // Some handlers will never come with a moduleId as they do not belong to any content module (dismiss, show..)
      (a) => a.kind === t,
      // Last hope, look for the None action - the default one
      (a) => a.kind === c.Fallback
    ];
    i && r.unshift((a) => a.moduleId === i);
    for (let a = 0; !n && a < r.length; a += 1)
      n = this.state.actions.find(r[a]);
    if (!n)
      return !1;
    let l = !1;
    return n.handler && (this.state.buttonState = b.Sending, l = await n.handler(s), this.state.buttonState = b.Active), Z.includes(t) && (this.state.stepActive = l ? g.Success : g.Failure, this.state.isFirstStep = !1), W.includes(t) && this.callHandler(c.Hide), G.includes(t) && this.state.hideFunction(), l;
  }
  goBackToMainStep() {
    this.state.stepPrevious = this.state.stepActive, this.state.stepActive = g.Main, this.state.isFirstStep = !0;
  }
  reset() {
    this.state.buttonState = b.Active, this.state.stepActive = g.Main, this.state.isFirstStep = !0;
  }
}
function Q(e, t = 1) {
  let i = e.replace("#", "");
  if (![3, 6].includes(i.length))
    return null;
  i.length === 3 && (i = i.split("").map((o) => o + o).join(""));
  const s = parseInt(i, 16);
  return `rgba(${s >> 16 & 255},${s >> 8 & 255},${s & 255},${t})`;
}
function mt(e) {
  const t = e.replace(/[-_\s]+(.)?/g, (i, s) => s ? s.toUpperCase() : "");
  return t.substring(0, 1).toUpperCase() + t.substring(1);
}
function Y(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
const ft = (e) => e.replace(/[A-Z]/g, (t) => `_${t.toLowerCase()}`);
function y(e) {
  switch ((e == null ? void 0 : e.kind) || f.Rounded) {
    case f.Custom:
      const i = e;
      return `${i.value}${i.format}`;
    case f.Square:
      return "0px";
    case f.Medium:
      return "6px";
    case f.Rounded:
    default:
      return "16px";
  }
}
function tt(e = 0) {
  return `${e}px`;
}
function bt(e = 0) {
  return `${e}%`;
}
function vt(e = 0) {
  return `${e}em`;
}
function T(e) {
  return `${e * 6 / 100}em`;
}
function et({
  format: e,
  top: t,
  right: i,
  bottom: s,
  left: o
}) {
  switch (e) {
    case V.Pixels:
      return `${t}${e} ${i}${e} ${s}${e} ${o}${e}`;
    case V.Em:
    default:
      return `${T(t)} ${T(i)} ${T(s)} ${T(o)}`;
  }
}
function st(e) {
  return (e == null ? void 0 : e.constructor) === Object;
}
function jt(e, t = 2) {
  return e.toFixed(0).padStart(t, "0");
}
function S(e) {
  const t = /^(&|&amp;|a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i, i = /([A-Za-z0-9\u00C0-\u00FF])/, s = /([ :–—-])/;
  return e.split(s).map((o, n, r) => o.search(t) > -1 && n !== 0 && n !== r.length - 1 && r[n - 3] !== ":" && r[n + 1] !== ":" && (r[n + 1] !== "-" || r[n - 1] === "-" && r[n + 1] === "-") ? o.toLowerCase() : o.substring(1).search(/[A-Z]|\../) > -1 || r[n + 1] === ":" && r[n + 2] !== "" ? o : o.replace(i, (l) => l.toUpperCase())).join("");
}
function it(e, t) {
  switch (e) {
    case "opacity":
      return (parseInt(t, 10) / 100).toString();
    case "thickness":
      return tt(parseInt(t, 10));
    case "cssName":
      return `'${t}'`;
    default:
      return t;
  }
}
function ot(e, t) {
  switch (e) {
    case "cornerRadius":
      return y(t);
    case "padding":
      return et(t);
    default:
      return null;
  }
}
function H(e, t) {
  return Object.keys(e).reduce((i, s) => {
    var n;
    let o = it(s, (n = e[s]) == null ? void 0 : n.toString());
    return st(e[s]) && (o = ot(s, e[s]), !o) ? {
      ...i,
      ...H(e[s], `${t}-${s}`)
    } : (i[`${t}-${Y(s)}`] = o, i);
  }, {});
}
class nt {
  constructor() {
    u(this, "rootDom", null);
    u(this, "state", v({
      colors: {},
      fonts: {},
      button: {},
      background: {},
      overlay: {}
    }));
  }
  get rootElement() {
    return this.rootDom;
  }
  get fonts() {
    return this.state.fonts;
  }
  get backgroundImage() {
    var t, i;
    return (i = (t = this.state.background.image) == null ? void 0 : t.urls) == null ? void 0 : i.edited;
  }
  get backgroundImageAlt() {
    var t;
    return (t = this.state.background.image) == null ? void 0 : t.alt;
  }
  get colors() {
    return this.state.colors;
  }
  get button() {
    return this.state.button;
  }
  initialize(t, i) {
    var o, n, r, l, a, h, m, p, $, k, A, z, M, C, F;
    this.rootDom = i, this.state.colors = t.colors || {}, this.state.fonts = t.fonts || {}, this.state.button = t.button || {}, this.state.background = t.background || {}, this.state.overlay = t.overlay || {};
    const s = H(this.state, "--thn-tool");
    this.addCssVariables({
      ...s,
      "--thn-tool-colors-icon-back": Q(((o = t.colors) == null ? void 0 : o.icon) || "#000000", 0.15),
      "--thn-tool-colors-background": (r = (n = t.colors) == null ? void 0 : n.background) != null && r.gradient ? `linear-gradient(to right bottom, ${(a = (l = t.colors) == null ? void 0 : l.background) == null ? void 0 : a.base}, ${(m = (h = t.colors) == null ? void 0 : h.background) == null ? void 0 : m.gradient})` : ($ = (p = t.colors) == null ? void 0 : p.background) == null ? void 0 : $.base,
      "--thn-tool-button-background-color": ((k = t.button) == null ? void 0 : k.style) === I.Solid ? (A = t.colors) == null ? void 0 : A.buttonBackground : "transparent",
      "--thn-tool-button-border": ((z = t.button) == null ? void 0 : z.style) === I.Outline ? `solid 2px ${(M = t.colors) == null ? void 0 : M.buttonBackground}` : "transparent",
      "--thn-tool-background-border": (F = (C = t.background) == null ? void 0 : C.border) != null && F.color ? `solid ${s["--thn-tool-background-border-thickness"]} ${t.background.border.color}` : "none"
    });
  }
  addCssVariables(t) {
    Object.keys(t).forEach((i) => {
      var s;
      (s = this.rootDom) == null || s.style.setProperty(i, t[i] || "");
    });
  }
  getCssVariableValue(t) {
    return this.rootDom && getComputedStyle(this.rootDom).getPropertyValue(t);
  }
}
const at = (e, t, i) => {
  const s = e[t];
  return s ? typeof s == "function" ? s() : Promise.resolve(s) : new Promise((o, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(n.bind(null, new Error("Unknown variable dynamic import: " + t + (t.split("/").length !== i ? ". Note that variables only represent file names one level deep." : ""))));
  });
};
class rt {
  constructor() {
    u(this, "state", v({
      language: d.English,
      device: w.Desktop,
      literals: {}
    }));
  }
  get device() {
    return this.state.device;
  }
  get language() {
    return this.state.language;
  }
  async initialize(t, i) {
    this.state.language = t ?? d.English, this.state.device = i ?? w.Desktop;
    const s = await at(/* @__PURE__ */ Object.assign({ "../locales/ar.json": () => import("./ar.CfXylqyO.js"), "../locales/bg.json": () => import("./bg.CvIJ3-AO.js"), "../locales/ca.json": () => import("./ca.ByoNEruG.js"), "../locales/cs.json": () => import("./cs.CLhmz00j.js"), "../locales/da.json": () => import("./da.eWEAm56t.js"), "../locales/de.json": () => import("./de.Bo_BtfXa.js"), "../locales/el.json": () => import("./el.DwVu6ZKE.js"), "../locales/en.json": () => import("./en.ChfA7XGi.js"), "../locales/es.json": () => import("./es.BcktWpVn.js"), "../locales/et.json": () => import("./et.C0wMkY2o.js"), "../locales/eu.json": () => import("./eu.BvLYxrRt.js"), "../locales/fi.json": () => import("./fi.DSAuZNOK.js"), "../locales/fr.json": () => import("./fr.DmJuyO8V.js"), "../locales/he.json": () => import("./he.CDO_nYXr.js"), "../locales/hr.json": () => import("./hr.6OS3NY1U.js"), "../locales/hu.json": () => import("./hu.sChuEUad.js"), "../locales/id.json": () => import("./id.CmNTBYDi.js"), "../locales/is.json": () => import("./is.DTejpmpw.js"), "../locales/it.json": () => import("./it.DuHi4BAa.js"), "../locales/ja.json": () => import("./ja.BB1shqzz.js"), "../locales/ko.json": () => import("./ko.CfoRc4Ly.js"), "../locales/lt.json": () => import("./lt.7OY5Sm1F.js"), "../locales/nl.json": () => import("./nl.BXN77qDs.js"), "../locales/no.json": () => import("./no.WF5RYR3r.js"), "../locales/pl.json": () => import("./pl.DWfwQC0k.js"), "../locales/pt.json": () => import("./pt.ByVny81e.js"), "../locales/ro.json": () => import("./ro.C9iL_aH4.js"), "../locales/ru.json": () => import("./ru.C1mbBNYs.js"), "../locales/sk.json": () => import("./sk.D8txdoFZ.js"), "../locales/sl.json": () => import("./sl.rPP52X3B.js"), "../locales/sv.json": () => import("./sv.CQgU08NU.js"), "../locales/th.json": () => import("./th.BHzkcM28.js"), "../locales/tr.json": () => import("./tr.B2562we6.js"), "../locales/uk.json": () => import("./uk.CQsFohgC.js"), "../locales/vi.json": () => import("./vi.rpwuKMpR.js"), "../locales/zh-TW.json": () => import("./zh-TW.D94xlrdh.js"), "../locales/zh.json": () => import("./zh.pRhOIjvA.js") }), `../locales/${this.state.language}.json`, 3);
    this.state.literals = s.default;
  }
  getLiteral(t, i) {
    return i ? S(this.state.literals[t] || t) : this.state.literals[t] || t;
  }
  getLiteralAbb(t, i) {
    const s = `${t}_abbr`;
    return this.getLiteral(s, i);
  }
  getActivityLiteral(t, i = {}) {
    var o;
    const s = i[t];
    return s ? (o = this.state.literals[O[t]]) == null ? void 0 : o.replace("XXXXXX", s) : this.state.literals[O[t]];
  }
  getPerkActiveLiteral(t, i = !1) {
    const s = t[this.state.language] || "";
    return i ? S(s) : s;
  }
  getPerkTooltipLiteral(t) {
    return this.state.literals[B[t]];
  }
  getActiveModuleText(t, i = !1) {
    const s = t[this.device][this.language] || "";
    return i ? S(s) : s;
  }
  getLocaleImageUrl(t) {
    var i;
    switch (t.languageType) {
      case j.Multi:
        return (i = t.urls[this.language || d.English]) == null ? void 0 : i.edited;
      case j.Single:
      default:
        return t.urls.edited;
    }
  }
  getLocaleImageAlt(t) {
    switch (t.languageType) {
      case j.Multi:
        return t.alt[this.language || d.English];
      case j.Single:
      default:
        return t.alt;
    }
  }
}
class lt {
  constructor() {
    u(this, "initTime", Date.now());
    u(this, "state", v({
      builderMode: !1,
      firstVisitDate: null,
      hotelTimezone: "Europe/Madrid",
      defaultAssets: void 0,
      countdownTimestamp: void 0,
      tokens: {}
    }));
  }
  get countdownInitTime() {
    return this.initTime;
  }
  get builderMode() {
    return this.state.builderMode;
  }
  get defaultAssets() {
    return this.state.defaultAssets;
  }
  get countdownTimestamp() {
    return this.state.countdownTimestamp;
  }
  get tokens() {
    return this.state.tokens;
  }
  initialize(t) {
    this.state.builderMode = !!t.builderMode, this.state.firstVisitDate = t.firstVisitDate, this.state.hotelTimezone = t.hotelTimezone, this.state.hotelTimezoneOffset = t.hotelTimezoneOffset, this.state.defaultAssets = t.defaultAssets, this.state.countdownTimestamp = t.countdownTimestamp, this.state.tokens = t.tokens;
  }
  getCountdownTimestamp(t, i) {
    const {
      date: s = Date.now(),
      timezone: o,
      days: n = 0,
      hours: r = 0,
      minutes: l = 0
    } = i;
    if (this.initTime = Date.now(), t === U.Time) {
      const a = n * 24 * 60 * 60 * 1e3, h = r * 60 * 60 * 1e3, m = l * 60 * 1e3, p = this.state.firstVisitDate ? this.initTime - this.state.firstVisitDate : 0;
      return this.initTime + a + h + m - p;
    }
    if (t === U.Date && s) {
      const a = new Date(s);
      if (a.setHours(r), a.setMinutes(l), o === N.Hotel)
        if (!this.state.hotelTimezoneOffset && this.state.hotelTimezone) {
          const h = (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
            timeZone: this.state.hotelTimezone
          }), p = new Date(h).getTime() - (/* @__PURE__ */ new Date()).getTime();
          a.setTime(a.getTime() - p);
        } else
          this.state.hotelTimezoneOffset && a.setTime(a.getTime() - this.state.hotelTimezoneOffset);
      return a.getTime();
    }
    return null;
  }
}
const P = new rt(), R = {}, _ = {};
function x() {
  const e = D();
  return (e == null ? void 0 : e.uid) || 0;
}
function ct() {
  var t;
  const e = D();
  return (t = e == null ? void 0 : e.proxy) == null ? void 0 : t.$el;
}
function ut(e) {
  var s;
  const t = D(), i = (s = t == null ? void 0 : t.exposed) == null ? void 0 : s.hide;
  e.inited = !0, e.hideFunction = i || (() => {
  });
}
function dt(e) {
  const t = x(), i = ct(), s = R[t];
  if (s.inited)
    s.language = e.language, s.rtl = e.language === d.Arabic || e.language === d.Hebrew, s.device = e.device, s.extraData.initialize(e.extraData), s.handlers.initialize(s.hideFunction, e.actions), s.literals.initialize(e.language, e.device), s.styles.initialize(e.styles, i);
  else
    throw new Error(`error updating store ${t}: store not inited`);
}
function Tt(e) {
  const t = x(), i = Symbol("useStore injection key"), s = v({
    uid: t,
    inited: !1,
    language: d.English,
    device: w.Desktop,
    hideFunction: () => {
    },
    extraData: new lt(),
    handlers: new J(),
    literals: P,
    styles: new nt()
  });
  return R[t] = s, _[t] = i, E(i, s), E("rootUID", t), q(() => {
    ut(s), dt(e);
  }), s;
}
function St() {
  const e = L("rootUID");
  if (e !== void 0)
    return L(_[e]);
  throw new Error("No UID found to load the store");
}
function wt() {
  return P;
}
export {
  b as B,
  at as _,
  Y as a,
  tt as b,
  ft as c,
  bt as d,
  vt as e,
  et as f,
  y as g,
  Q as h,
  st as i,
  S as j,
  Tt as k,
  St as l,
  wt as m,
  jt as p,
  mt as t,
  dt as u
};
//# sourceMappingURL=useStore.BDcvoiVN.js.map
